import React, { useEffect } from 'react';
import { SunIcon, MoonIcon } from 'lucide-react';
interface ThemeToggleProps {
  isDark: boolean;
  toggleTheme: () => void;
}
export function ThemeToggle({
  isDark,
  toggleTheme
}: ThemeToggleProps) {
  return <button onClick={toggleTheme} className="relative w-10 h-10 rounded-full flex items-center justify-center overflow-hidden group" aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'} data-id="element-377">
      <div className="absolute inset-0 bg-neutral-100 dark:bg-neutral-900 opacity-0 group-hover:opacity-20 transition-opacity duration-300 rounded-full" data-id="element-378" />
      {isDark ? <SunIcon className="w-5 h-5 text-white transition-all" data-id="element-379" /> : <MoonIcon className="w-5 h-5 text-black transition-all" data-id="element-380" />}
    </button>;
}